import React, { useState } from "react";
import { Mail, Phone, MapPin, ChevronDown } from "lucide-react";

const faqs = [
    {
        question: "Can I upgrade or downgrade my plan anytime?",
        answer:
            "Yes! You can change your plan at any time. Upgrades take effect immediately, and downgrades will take effect at the end of your current billing period.",
    },
    {
        question: "What payment methods do you accept?",
        answer:
            "We accept bank transfers, debit cards, USSD, and mobile money payments. All payments are secured with bank-level encryption.",
    },
    {
        question: "Is the Free plan really free forever?",
        answer:
            "Yes! Our Free plan gives you permanent access to basic features. No credit card required, no hidden fees.",
    },
    {
        question: "Can I get a refund if I'm not satisfied?",
        answer:
            "Unfortunately, No, we do not refund once payment has been received, we do not however believe you will need a refund, with the tools we will continue to create for you.",
    },
];

const ContactPage = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <>
            {/* Contact Section */}
            <section
                id="contact"
                className="py-24 relative min-h-screen flex items-center"
                style={{
                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65)), url('https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=2069&q=80')`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundAttachment: "fixed",
                }}
            >
                <div className="container mx-auto px-6 relative z-10">
                    <h2 className="text-4xl md:text-5xl font-bold text-white text-center mb-6">
                        Contact Us
                    </h2>
                    <p className="text-gray-200 text-center mb-12 text-lg">
                        Have questions? We'd love to hear from you!
                    </p>

                    <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto">
                        {/* Contact Info */}
                        <div className="bg-white/10 backdrop-blur-xl rounded-2xl border border-white/30 shadow-xl p-8 flex flex-col justify-center transition-transform duration-300 hover:scale-[1.02]">
                            <h3 className="text-2xl font-semibold text-white mb-6">
                                Get in Touch
                            </h3>
                            <div className="space-y-5">
                                <div className="flex items-center space-x-4">
                                    <Mail className="text-[#2148C0]" />
                                    <a
                                        href="mailto:support@TeeChaa.com"
                                        className="text-white hover:underline"
                                    >
                                        support@TeeChaa.com
                                    </a>
                                </div>
                                {/* <div className="flex items-center space-x-4">
                                    <Phone className="text-[#2148C0]" />
                                    <a
                                        href="tel:+2348001234567"
                                        className="text-white hover:underline"
                                    >
                                        +234 800 123 4567
                                    </a>
                                </div> */}
                                <div className="flex items-center space-x-4">
                                    <MapPin className="text-[#2148C0]" />
                                    <p className="text-white">Lagos, Nigeria</p>
                                </div>
                            </div>
                        </div>

                        {/* Contact Form */}
                        <form className="bg-white/10 backdrop-blur-xl rounded-2xl border border-white/30 shadow-xl p-8 space-y-5 transition-transform duration-300 hover:scale-[1.02]">
                            <div>
                                <label
                                    htmlFor="name"
                                    className="block text-sm font-medium text-gray-200 mb-2"
                                >
                                    Your Name
                                </label>
                                <input
                                    id="name"
                                    type="text"
                                    placeholder="John Doe"
                                    className="w-full border border-gray-300/50 p-3 rounded-lg focus:ring-2 focus:ring-[#2148C0] focus:outline-none bg-white/20 text-white placeholder-gray-300"
                                    required
                                />
                            </div>
                            <div>
                                <label
                                    htmlFor="email"
                                    className="block text-sm font-medium text-gray-200 mb-2"
                                >
                                    Your Email
                                </label>
                                <input
                                    id="email"
                                    type="email"
                                    placeholder="you@example.com"
                                    className="w-full border border-gray-300/50 p-3 rounded-lg focus:ring-2 focus:ring-[#2148C0] focus:outline-none bg-white/20 text-white placeholder-gray-300"
                                    required
                                />
                            </div>
                            <div>
                                <label
                                    htmlFor="message"
                                    className="block text-sm font-medium text-gray-200 mb-2"
                                >
                                    Your Message
                                </label>
                                <textarea
                                    id="message"
                                    placeholder="Write your message..."
                                    className="w-full border border-gray-300/50 p-3 rounded-lg h-32 focus:ring-2 focus:ring-[#2148C0] focus:outline-none bg-white/20 text-white placeholder-gray-300"
                                    required
                                ></textarea>
                            </div>
                            <button
                                type="submit"
                                className="w-full bg-[#2148C0] text-white px-6 py-3 rounded-lg font-semibold shadow-lg hover:bg-blue-700 transition-all duration-300 transform hover:scale-105"
                            >
                                Send Message
                            </button>
                        </form>
                    </div>
                </div>
            </section>

            {/* FAQ Section */}
            <section className="py-24 bg-gray-50">
                <div className="container mx-auto px-6">
                    <div className="text-center mb-16">
                        <h2 className="text-4xl font-bold text-gray-800 mb-4">
                            Frequently Asked Questions
                        </h2>
                        <p className="text-gray-600 max-w-2xl mx-auto">
                            Find quick answers to the most common questions.
                        </p>
                    </div>

                    <div className="max-w-3xl mx-auto space-y-4">
                        {faqs.map((faq, index) => (
                            <div
                                key={index}
                                className="bg-white p-6 rounded-2xl shadow-md cursor-pointer border border-gray-100 transition hover:shadow-lg"
                                onClick={() => toggleFAQ(index)}
                            >
                                <div className="flex items-center justify-between">
                                    <h3 className="text-lg font-semibold text-gray-800">
                                        {faq.question}
                                    </h3>
                                    <ChevronDown
                                        className={`transition-transform duration-300 ${openIndex === index ? "rotate-180" : ""
                                            }`}
                                    />
                                </div>
                                {openIndex === index && (
                                    <p className="text-gray-600 mt-3">{faq.answer}</p>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default ContactPage;
